function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, PaginationListStandalone } from 'react-bootstrap-table2-paginator';

class RemotePaginationTable extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      const {
        data,
        page,
        sizePerPage,
        onTableChange,
        totalSize,
        columns,
        bordered
      } = this.props;
      return /*#__PURE__*/React.createElement(PaginationProvider, {
        pagination: paginationFactory({
          custom: true,
          page,
          sizePerPage: sizePerPage,
          totalSize
        })
      }, ({
        paginationProps,
        paginationTableProps
      }) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BootstrapTable, _extends({
        remote: true,
        keyField: "id",
        data: data,
        columns: columns,
        onTableChange: onTableChange,
        bordered: !!bordered,
        headerClasses: "thead-light",
        wrapperClasses: "table-responsive"
      }, paginationTableProps)), /*#__PURE__*/React.createElement("div", {
        className: "mb-2 float-right"
      }, /*#__PURE__*/React.createElement(PaginationListStandalone, paginationProps))));
    });
  }

}

export default RemotePaginationTable;